<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="70%"
    @close="clearAddSmallWeChatInfo"
  >
    <el-form label-width="120px">
      <el-form-item label="名称" required>
        <el-input
          v-model="addSmallWeChatInfo.name"
          placeholder="必填，请填写名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付密码" required>
        <el-input
          v-model="addSmallWeChatInfo.payPassword"
          placeholder="必填，请填写支付密码"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="商户ID" required>
        <el-input
          v-model="addSmallWeChatInfo.mchId"
          placeholder="必填，请填写商户ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户名称" required>
        <el-input
          v-model="addSmallWeChatInfo.mchName"
          placeholder="必填，请填写商户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="商户证书">
        <upload-file
          ref="uploadFile"
          namespace="addSmallWeChat"
          @notifyCert="handleCertUpload"
        ></upload-file>
      </el-form-item>
      <el-form-item label="描述">
        <el-input
          v-model="addSmallWeChatInfo.remarks"
          type="textarea"
          placeholder="选填，请填写描述信息"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveSmallWeChatInfo">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveSmallWeChat } from '@/api/goods/smallWeChatApi'
import { getShopId, getDict } from '@/api/shop/shopApi'
import UploadFile from '@/components/frame/uploadFile/uploadFile.vue'

export default {
  name: 'AddSmallWeChat',
  components: {
    UploadFile
  },
  data() {
    return {
      dialogVisible: false,
      addSmallWeChatInfo: {
        weChatId: '',
        name: '',
        appId: '-1',
        appSecret: '-1',
        payPassword: '',
        objType: '1000',
        objId: '',
        mchId: '',
        mchName: '',
        remarks: '',
        objTypes: [],
        types: [],
        weChatType: '',
        certPath: ''
      }
    }
  },
  methods: {
    open(type) {
      this.addSmallWeChatInfo.weChatType = type
      this.getDictData()
      this.dialogVisible = true
    },
    async getDictData() {
      try {
        const {data: objTypes} = await getDict('small_wechat', 'obj_type')
        const {data: types} = await getDict('small_wechat', 'wechat_type')
        this.addSmallWeChatInfo.objTypes = objTypes
        this.addSmallWeChatInfo.types = types
        this.addSmallWeChatInfo.objId = getShopId()
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleCertUpload(param) {
      this.addSmallWeChatInfo.certPath = param.realFileName
    },
    addSmallWeChatValidate() {
      // 验证逻辑保持不变
      // ...
    },
    saveSmallWeChatInfo() {
      if (!this.addSmallWeChatValidate()) {
        this.$message.error(this.validateErrInfo)
        return
      }

      this.addSmallWeChatInfo.objId = getShopId()
      saveSmallWeChat(this.addSmallWeChatInfo)
        .then(response => {
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.$emit('listSmallWeChat')
        })
        .catch(error => {
          this.$message.error(error.message || '添加失败')
        })
    },
    clearAddSmallWeChatInfo() {
      this.addSmallWeChatInfo = {
        weChatId: '',
        name: '',
        appId: '',
        appSecret: '',
        payPassword: '',
        objType: '',
        objId: '',
        mchId: '',
        mchName: '',
        weChatType: '',
        types: this.addSmallWeChatInfo.types,
        remarks: '',
        objTypes: this.addSmallWeChatInfo.objTypes,
        certPath: ''
      }
      this.$refs.uploadFile.clearVedio()
    }
  }
}
</script>